import { loader } from 'graphql.macro';

export const surfaceDetailsFragment = loader('./index.graphql');
